import {
	useDeleteQuizMutation,
	useGetQuizzesQuery,
} from "../../../features/quiz/quizApi";
import Loading from "../../../components/ui/Loading";
import Error from "../../../components/ui/Error";
import EmptyResult from "../../../components/ui/EmptyResult";
import Table from "../../ui/Table";
import TableRow from "../../ui/TableRow";
import { Link } from "react-router-dom";
import MessageToast from "../../ui/MessageToast";

export default function Quizzes() {
	const {
		data: quizzes,
		isLoading: isGetQuizzesLoading,
		isError: isGetQuizzesError,
	} = useGetQuizzesQuery() || {};
	
	const [
		deleteQuiz,
		{ isError: isQuizDeleteError, isSuccess: isQuizDeleteSuccess },
	] = useDeleteQuizMutation() || [];

	const quizDeleteHandler = (quizId) => {
		deleteQuiz(quizId);
	};

	//Decide what to render
	let content = null;
	if (isGetQuizzesLoading) {
		content = <Loading />;
	} else if (!isGetQuizzesLoading && isGetQuizzesError) {
		content = <Error message="There was an error!" />;
	} else if (
		!isGetQuizzesLoading &&
		!isGetQuizzesError &&
		quizzes?.length === 0
	) {
		content = <EmptyResult message="No quizzes found, please add" />;
	} else if (
		!isGetQuizzesLoading &&
		!isGetQuizzesError &&
		quizzes?.length > 0
	) {
		const headers = ["Question", "Video", "Action"];
		content = (
			<Table headers={headers}>
				{quizzes.map((quiz) => (
					<TableRow
						key={quiz.id}
						data={[quiz.question, quiz.video_title]}
						editRoute={`/admin/quizzes/edit/${quiz.id}`}
						deleteCallBack={quizDeleteHandler}
						dataId={quiz.id}
					/>
				))}
			</Table>
		);
	}

	return (
		<section className="py-6 bg-primary">
			<div className="mx-auto max-w-full px-5 lg:px-20">
				<div className="px-3 py-20 bg-opacity-10">
					<div className="w-full flex">
						<Link to="add" className="btn ml-auto">
							Add Quiz
						</Link>
					</div>
					<div className="overflow-x-auto mt-4">{content}</div>
				</div>
			</div>

			{isQuizDeleteSuccess && (
				<MessageToast message="Quiz delete successful" />
			)}
			{isQuizDeleteError && (
				<MessageToast
					message="There was an error while deleting quiz!"
					type="error"
					delay={3000}
				/>
			)}
		</section>
	);
}
